export default [
  { text: "product.product_status.DRAFT", value: "DRAFT" },
  { text: "product.product_status.PUBLIC", value: "PUBLIC" },
  { text: "product.product_status.DISABLED", value: "DISABLED" },
];
